import React from "react";
import Footer from "../../Footer.js/Footer";
import NavbarComplete from "../Navbar/NavbarComplete";

const FullLayout = ({ children }) => {
  const registerButtonBackgroundColor =
    "linear-gradient(161.42deg, #6EE8FC 5.47%, #6AE2FB 21.27%, #5ED1F7 42.01%, #4BB5F1 65.72%, #308EE8 91.39%, #267FE5 100.28%)";

  const loginButtonBackgroundColor = "transparent";

  return (
    <div className="flex flex-col min-h-screen">
      <NavbarComplete
        loginButtonText="ثبت نام"
        loginButtonGradient={registerButtonBackgroundColor}
        signupButtonText="ورود"
        signupButtonGradient={loginButtonBackgroundColor}
        signupTextColor="text-white"
        signupBorder="border-2 border-sky-500"
      />
      <main className="flex-grow mx-auto m-10 mb-0 ">{children}</main>
      <Footer />
    </div>
  );
};

export default FullLayout;
